// extracted by mini-css-extract-plugin
module.exports = {"AppPage":"AppPage_AppPage__EKmNy"};